import { t } from "@lingui/macro";

export const EmptyCategory = () => (
  <p className="text-center">{t`No items for this budget category`}</p>
);
